import { SHOW_POPUP, HIDE_POPUP } from "actions/popupActions";

const initialState = {
  isActive: false,
  element: null,
  callback: null,
  isLight: false,
  showClose: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SHOW_POPUP:
      return {
        ...initialState,
        isActive: true,
        element: action.payload.element,
        callback: action.payload.callback,
        showClose: !!action.payload.showClose,
        isLight: !!action.payload.isLight,
      };

    case HIDE_POPUP:
      return {
        ...state,
        isActive: false,
        callback: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/popupReducer.js